"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { HOME_GRADIENT_HEADER } from "../foundations/home-tokens";

export interface HomeHeroHeaderV2Props {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  density?: "default" | "compact";
}

export function HomeHeroHeaderV2({
  title,
  description,
  icon,
  actions,
  density = "default"
}: HomeHeroHeaderV2Props) {
  return (
    <header
      className={cn(
        HOME_GRADIENT_HEADER,
        "relative overflow-hidden rounded-t-xl shadow-xl",
        density === "default" ? "px-6 py-8" : "px-4 py-6"
      )}
    >
      <div className="absolute inset-0 bg-black/10" />
      <div className="relative flex items-center justify-between gap-4">
        <div className="flex items-center space-x-3 text-white">
          {icon}
          <div>
            <h1 className="text-3xl font-bold">{title}</h1>
            {description && <p className="mt-1 text-blue-100">{description}</p>}
          </div>
        </div>
        {actions}
      </div>
      <div className="absolute -bottom-4 -right-4 h-32 w-32 rounded-full bg-white/10" />
      <div className="absolute -left-4 -top-4 h-20 w-20 rounded-full bg-white/10" />
    </header>
  );
}
